
import { useEffect, useState } from "react";
import { Button, Col, Container, OffcanvasBody, OffcanvasHeader, Row } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenViewRecievedEmailPubSub, OpenViewRecievedEmailPubSubPayload } from "@utils/pubsubs/PubSub";
import SecureHTMLRender from "@components/content/SecureHTMLRender";
import AttachmentDownloadLink from "@components/content/AttachmentDownloadLink";
import { ReceivedEmailApi, ReceivedEmailDataType } from "@/api/ReceivedEmailApi";
import { ReceivedAttachmentApi, ReceivedAttachmentDataType } from "@/api/ReceivedAttachmentApi";
import LoadingScreen from "@components/content/LoadingScreen";
import { pickEmailBody } from "@utils/emailBody";

type ViewRecievedEmailOffCanvasProps = {
} & DefaultOffCanvasProps

const ViewRecievedEmailOffCanvas = (props: ViewRecievedEmailOffCanvasProps) => {
    const { btnColor = "primary", className } = props;
    const [isOpen, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [emailData, setEmailData] = useState<ReceivedEmailDataType>({})
    const [emailAttachments, setEmailAttachments] = useState<ReceivedAttachmentDataType[]>([])

    useEffect(() => {
        const unsubscribe = OpenViewRecievedEmailPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenViewRecievedEmailPubSubPayload) => {
        setIsLoading(true)
        const { openOffCanvas = false, emailId } = payload;

        try {
            setOpen(openOffCanvas);
            await loadEmailData(emailId);
        } finally {
            setIsLoading(false)
        }
    }

    const loadEmailData = async (recievedEmailId: string) => {
        const { items: attachments } = await ReceivedAttachmentApi.getByRecievedEmailId(recievedEmailId);
        setEmailAttachments(attachments)

        const email = await ReceivedEmailApi.get(recievedEmailId);
        setEmailData(email)
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const renderAttachments = () => {
        if (emailAttachments && emailAttachments.length > 0) {
            return (
                <div className={styles.fileAttachmentGrid}>
                    <b>Adjuntos:</b>
                    {emailAttachments.map(ae => (
                        <AttachmentDownloadLink
                            key={ae.s3Key}
                            bucketName="recievedProviderEmails"
                            item={{
                                label: `${ae.filename}`,
                                s3Key: `${ae.s3Key}`,
                                fileType: `${ae.mimeType}`.includes("pdf") ? "pdf" : "xml",
                            }}
                        />
                    ))}
                </div>
            )
        }
    }

    const renderBody = () => {
        const { content, isPlainText, isEmpty } = pickEmailBody(emailData);

        if (isEmpty) {
            return (
                <p data-testid="email-empty-body">
                    Este correo no tiene contenido; revise los adjuntos.
                </p>
            )
        }

        return (
            <SecureHTMLRender
                htmlBody={content}
                isPlainText={isPlainText}
            />
        )
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Ver Correo De Factura Electronica
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Row>
                            <Col
                                xs="2"
                                md="1"
                            >
                                <b>De:</b>
                            </Col>
                            <Col>
                                {emailData?.from}
                            </Col>
                        </Row>
                        <Row>
                            <Col
                                xs="2"
                                md="1"
                            >
                                <b>Asunto:</b>
                            </Col>
                            <Col>
                                {emailData?.subject}
                            </Col>
                        </Row>
                        <hr />
                        {renderAttachments()}
                        <Row>
                            <Col>
                                {renderBody()}
                            </Col>
                        </Row>
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
            <LoadingScreen isLoading={isLoading} />
        </>
    );
}
export default ViewRecievedEmailOffCanvas;
